import React from 'react';
import Grid from '@mui/material/Grid';
import MobileSwiper from '@/components/mobile/MobileSwiper';
import SimilarJobTitleCard from '@/components/job-title/similar-job-title/Card';
import SeoSwiper from '@/components/swiper/SeoSwiper';
import { useClintMediaQuery } from '@/utils/hooks';

interface Props {
  data: {
    page_path: string;
  }[];
}

const MoreJobTitle = (props: Props) => {
  const { data } = props;
  const isMobile = useClintMediaQuery();

  return (
    <div className="text-black mt-8">
      <p className="text-xl font-semibold tablet:text-2xl tablet:font-medium">
        更多职位
      </p>
      <Grid container={!isMobile} spacing={isMobile ? undefined : 2}>
        <Grid item={!isMobile} className="w-full">
          <div className="mt-8 tablet:mt-4 w-full">
            {isMobile ? (
              <MobileSwiper
                chunkSize={6}
                slideClassName={`grid ${data.length > 4 ? 'grid-rows-3' : data.length > 2 ? 'grid-rows-2' : 'grid-rows-1'} grid-cols-2 gap-x-3 gap-y-4`}
                chunkData={data}
                swiperEle={({
                  page_path: pagePath,
                  page_data: {
                    id,
                    salary,
                    name,
                    description,
                    city_pinyin: cityPinyin,
                    city_name: cityName,
                  },
                }) => (
                  <SimilarJobTitleCard
                    key={pagePath}
                    id={id}
                    city={{
                      name: cityName,
                      pinyin: cityPinyin,
                    }}
                    name={name}
                    salary={salary ?? 'NaN'}
                    isJobTitlePage={true}
                    description={description}
                    dataEleGroup="job-title_more-job"
                  />
                )}
              />
            ) : (
              <SeoSwiper
                chunkData={data}
                chunkSize={4}
                slideClassName="grid-cols-4 grid-rows-1"
                swiperEle={({
                  page_path: pagePath,
                  page_data: {
                    id,
                    salary,
                    name,
                    description,
                    city_pinyin: cityPinyin,
                    city_name: cityName,
                  },
                }) => (
                  <SimilarJobTitleCard
                    key={pagePath}
                    id={id}
                    city={{
                      name: cityName,
                      pinyin: cityPinyin,
                    }}
                    name={name}
                    salary={salary ?? 'NaN'}
                    isJobTitlePage={true}
                    description={description}
                    dataEleGroup="job-title_more-job"
                  />
                )}
              />
            )}
          </div>
        </Grid>
      </Grid>
    </div>
  );
};

export default MoreJobTitle;
